module.exports = new __parcel__URL__("closed-hihat_10.51d068e3.mp3").toString();